import { AgentQAJobStatus } from 'types/agentQA';

export function agentQAJobStatusRenderer(params: { value?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = params.value;

  switch (status) {
    case AgentQAJobStatus.PENDING:
      // Hourglass icon for pending
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';

    case AgentQAJobStatus.RUNNING:
      // Spinner icon for running
      return '<span class="fa fa-spinner fa-spin" style="color: #2196f3;" title="Running"></span>';

    case AgentQAJobStatus.DONE:
      // Check circle icon for done
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';

    default:
      return '';
  }
}
